import { createRoute } from '@tanstack/react-router'
import { UnauthorizedPage } from '@/features/auth/pages/UnauthorizedPage'
import { Route as rootRoute } from './__root'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/unauthorized',
  component: UnauthorizedPage,
})
